import { useEffect, useState } from "react";
import "../styles/success.css";
import { getDisplayPrice } from "../helper/products";
import { PMT } from "../classes/Enum";
import { useAuth } from "./AuthProvider";

const SuccessComponent = ({ transactionId, totalPrice, cart, fetchProduct, setCart, paymentMethod, email }) => {
  const [products, setProducts] = useState([]);
  const {user} = useAuth();

  useEffect(() => {
    window.scrollTo({ top: 0 });

    // 1) Snapshot products from cart ONCE (before clearing cart)
    const snapshot = cart
      .map(ci => fetchProduct(ci.productId))   // sync lookup
      .filter(Boolean);

    setProducts(snapshot);

    // 2) Now clear the global cart
  }, []); // run once when SUCCESS mounts

  return (
    <div id="success" className="hide-scrollbar">
      <h1>Checkout successful!</h1>

      {paymentMethod === PMT.PAYID && (
        <form className="payid">
          <label>PayID Payment Instructions:</label>
          <input type="text" value="THE AVERAGE COLLECTOR PTY LTD" readOnly />
          <label>PAY ID:</label>
          <input type="text" value="80 6868 222 11" readOnly />
          <label>Total Amount:</label>
          <input type="text" value={getDisplayPrice(totalPrice)} readOnly />
          <label>Add to Description:</label>
          <input type="text" value={`Order #${transactionId}`} readOnly />
        </form>
      )}

      {!user && <>
      <h1>We created an account for you to track orders and start collecting!</h1>
        <h1>
          Log in with the details sent to {email}
        </h1>
      </>}

    </div>
  );
};

export default SuccessComponent;
